// import * as Sentry from '@sentry/react';
/* Endpoints
---------------------------------------------*/
export const ENDPOINT_PERFORM_LOGIN = '/perform_login?client_id=' + window.backendData.clientId;
export const ENDPOINT_CONFIRM_ACCESS = '/confirm_access' + (window.backendData.styleHint ? '?style_hint=' + window.backendData.styleHint : '');
export const ENDPOINT_UPDATE_USER = '/update_user';
export const ENDPOINT_GENERATE_PHONE_CODE = '/generate_phone_verification_code';
export const ENDPOINT_VERIFY_PHONE_CODE = '/verify_phone_verification_code';
export const ENDPOINT_SENT_VERIFICATION_MAIL = '/send_verification_mail';
export const ENDPOINT_DEVICE_USER_CODE = '/device/user_code';
export const ENDPOINT_DEVICE_NAME = '/device_name'
export const ENDPOINT_SUBPROFILE_LOGIN_UPDATE = '/subprofile_login/update';
export const ENDPOINT_SUBPROFILE_LOGIN_STATUS = '/subprofile_login/status';
export const ENDPOINT_SUBPROFILE_LOGIN_CLAIM = '/subprofile_login/claim';
export const ENDPOINT_SUBPROFILE_LOGIN_CONFIRM = '/subprofile_login/confirm';
export const ENDPOINT_SUBPROFILE_LOGIN_REMOTE_USER_CODE = '/subprofile_login_remote/user_code';
export const ENDPOINT_SUBPROFILE_LOGIN_REMOTE_CLAIM = '/subprofile_login_remote/claim';


/* Perform Login
---------------------------------------------*/
export const performLogin = (data, csrfToken) => {

	// define form fields
	const inputFields = {
		UID: data.UID,
		UIDSignature: data.UIDSignature,
		signatureTimestamp: data.signatureTimestamp
	};

	postDataAsForm(ENDPOINT_PERFORM_LOGIN, csrfToken, inputFields);
};



/* POST form data
---------------------------------------------*/
export const postDataAsForm = (url = '', csrfToken, inputFields = {}) => {

	try {
		// define form
		const form = document.createElement('form');
		form.action = url;
		form.method = 'POST';
		form.style.display = 'none';

		// define input fields
		Object.keys(inputFields).forEach((key) => {

			// check
			if (inputFields[key]) {
				const element = createHiddenInputElement(key, inputFields[key]);
				form.appendChild(element);

			} else {
				// log error
				// eslint-disable-next-line no-console
				console.log(url + `: Missing value for key ${inputFields[key]}`);
			}
		});

		if (csrfToken) {
			const element = createHiddenInputElement('_csrf', csrfToken);
			form.appendChild(element);
		}

		// actions
		document.body.appendChild(form);
		form.submit();
		document.body.removeChild(form);
	} catch (error) {
		// Sentry.captureException(error);
	}
};

const createHiddenInputElement = (key, value) => {
	const element = document.createElement('input');
	element.type = 'hidden';
	element.name = key;
	element.value = value;
	return element;
};



/* POST data
---------------------------------------------*/
export async function postData(url = '', csrfToken = '', data = {}, tag) {
	return await fetch(url, {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'OIDCXSRF': csrfToken
		},
		credentials: 'include', // devried: should be same-origin US-1408
		body: JSON.stringify(data)
	}).then((response) => {
		return response;
	}).catch((error) => {
		sentryException(error, tag);
		throw error
	});
}

export async function getData(url = '', data = {}, tag) {
	const params = new URLSearchParams();
	Object.entries(data).forEach(([key,value]) => params.append(key, value));

	return await fetch(`${url}?${params}`, {
		method: 'GET',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		},
	}).then((response) => {
		return response;
	}).catch((error) => {
		sentryException(error, tag);
		throw error
	});
}

/* Sentry functions
---------------------------------------------*/
function setSentryTag(tag) {
	if (tag) {
		Object.keys(tag).forEach((tagName) => {
			// Sentry.setTag(tagName, tag[tagName]);
			// eslint-disable-next-line no-console
			console.log(tagName);
		});
	}
}

export function sentryException(error, tag) {
	try {
		setSentryTag(tag);
		const msg = error instanceof Error ? error : new Error(JSON.stringify(error));
		if (error.errorMessage) {
			msg.name = error.errorMessage;
		}
		// Sentry.captureException(msg);
	} catch (e) {
		// eslint-disable-next-line no-console
		console.log(e);
	}
}

export function sentryLogData(data) {
	// try {
	// 	if (data.mail) {
	// 		// Sentry.setUser({ email: data.mail });
	//
	// 	// 	level: "info",
	// 	// 	message: JSON.stringify(data),
	// 	// });
	// } catch (e) {
	// 	// eslint-disable-next-line no-console
	// 	console.log(e);
	// }
	// eslint-disable-next-line no-console
	console.log(data)
}
